export default "__VITE_ASSET__Da10WxVE__"